import { all, fork } from 'redux-saga/effects';
import { deliveryPromiseSaga } from './delivery-promise';
import { waitlistSubscriptionSaga } from './waitlist-subscription';

export function* rootSaga() {
    yield all([
        fork(deliveryPromiseSaga),
        fork(waitlistSubscriptionSaga)
    ]);
}